import React, { useEffect } from 'react';
import { WppButton, WppIconFluidWorkflow } from '@wppopen/components-library-react';
import { useDispatch, useSelector } from 'react-redux';
import { buttonStateSlice } from 'Redux/redirectButtonSlice';
import { updateSitId, updateRedirect, updateRedirectUrl } from 'Redux/redirectButtonSlice';
import { ButtonWrapper } from './RedirectButtonStyles';

type buttonSize = 's' | 'm' | undefined;

interface RedirectButtonProps {
    size?: buttonSize;
}

export const RedirectButton = ({ size = 'm' }: RedirectButtonProps) => {
    const dispatch = useDispatch();

    const { sitIdValue, redirectFromValue, redirectUrlValue } = useSelector(buttonStateSlice);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const sitId = params.get('sitId');
        const redirectFrom = params.get('redirectFrom');
        const redirectUrl = params.get('redirectUrl');

        if (sitId) {
            dispatch(updateSitId({ sitIdValue: sitId }));
        }

        if (redirectFrom) {
            dispatch(updateRedirect({ redirectFromValue: redirectFrom }));
        }

        if (redirectUrl) {
            dispatch(updateRedirectUrl({ redirectUrlValue: redirectUrl }));
        }
    }, [dispatch]);

    const redirectHandler = () => {
        switch (true) {
            case redirectFromValue?.includes('dashboard'):
                window.history.pushState({}, '', `/dashboard/${sitIdValue}?scrollToModule=oppSim`);
                break;

            case redirectFromValue?.includes('modules') && !!redirectUrlValue:
                window.history.pushState({}, '', `/${redirectUrlValue}`);
                break;

            default:
                window.history.pushState({}, '', `/welcome-page/${sitIdValue}`);
                break;
        }
    };

    return (
        <ButtonWrapper isVisible={Boolean(sitIdValue)}>
            <WppButton
                variant="secondary"
                size={size}
                onClick={redirectHandler}
                data-testid="WIDGET.REDIRECT.BUTTON.MAIN"
            >
                <WppIconFluidWorkflow slot="icon-start" size="s" />
                Go to Strategic Insights
            </WppButton>
        </ButtonWrapper>
    );
};
